import { Button } from '@mui/material';
import * as React from 'react';
import API from '../../api/axiosConfig';

export default function ClearEntriesButton(){

    // Set up variable to hold and set the user email
    const [userEmail, setUserEmail] = React.useState(null);

    React.useEffect(() => {
        // Fetch user email from the backend
        const fetchUserEmail = async () => {
            try {

                // Fetch email
                const infoResponse = await API.post('/api/users/info');

                // Set user details to state
                // Added '' to protect from null values
                setUserEmail(infoResponse.data.email || '');

            } catch (err) {
                if (err.response?.status !== 401) {
                    // alert("Error fetching user email! Check console for more details.")
                    console.error("Error fetching user email:", err);
                }
            }
        };

        fetchUserEmail();
    }, []); // Empty array means "run once on mount"

    const handleClick = async () => {
        const confirmed = window.confirm(
            "Are you sure you wish to delete all current insurance entries? WARNING: THIS CANNOT BE UNDONE!"
        );

        if(confirmed){
            try {

                // delete all
                await API.post('/api/insurance/deleteall');

                alert("Insurance entries database cleared.");

            } catch (err) {
                if (err.response?.status === 403){
                    alert("ERROR: You are not permitted to delete insurance information.");
                } else if (err.response?.status !== 401) {
                    console.error("Error sending insurance summary:", err);
                    alert("An unexpected error ocurred while clearing the database.");
                }
            }
        }
    };

    // Return the rendered button if Gary or CJ is the user signed into the system. Otherwise, return nothing.
    return(
        <div>
            {userEmail === "gary@s3k.io" || userEmail === "cj.polesovsky@s3k.io" ? (
                <Button
                    variant="outlined"
                    onClick={handleClick}
                >
                    Clear Insurance Database
                </Button>
            ) : null }
        </div>


    );
}